import { TProject } from 'app-entities/projects/types/project.type';
import { deleteSpacesFromImageLink } from 'app-entities/projects/helpers/delete-spaces-from-image-link.helper';
import { getImageLinkWithWebPFormat } from 'app-entities/projects/helpers/get-image-link-with-web-p-format.helper';

export const mapProjectsResponseForUiModel = (projects: TProject[]) => {
  return projects.map(item => {
    const { mainPictureLink, projectMinPrice } = item;
    const fixedLink = deleteSpacesFromImageLink(mainPictureLink);

    return {
      ...item,
      projectMinPrice: projectMinPrice ? parseInt(projectMinPrice) : null,
      mainPictureLink: fixedLink,
      mainPictureLinkInWebPFormat: getImageLinkWithWebPFormat(fixedLink),
    };
  });
};
